import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/**
 * Wrapper on top of ngx-translate to provide consistent Translations and other
 * i18n infrastructure to Salaxy components and web sites using them.  NOTE: If
 * you need new methods from ngx-translate, you may add them here.  Also, the
 * idea is to always uyse this service instead of using ngx-translate
 * TranslateService directly, so that later we may move to another translations
 * framework.  Note that views may use the Translate pipe directly (e.g.
 * "{{'SETTINGS.GeneralSettingsPageTitle' | translate}}") We can then later
 * easily change how this pipe is resolved.
 */
@Injectable()
export class NgTranslations {

    /** Creates a new instance of CalculationRepository with dependency injection. */
    constructor(
        @Inject(TranslateService) private translateSrv: TranslateService,
    ) {

    }

    /**
     * Gets the translated value of a key (or an array of keys) synchronously
     * Main point here is that we do not use the async promise infrastructure
     * of ngx-translate as it is obsolete for us.  The translations must be
     * loaded as the app loads: It does not make sense to allow loading them
     * from server asyncronously.
     * @param key
     * @param interpolateParams
     * @returns the translated key, or an object of translated keys
     */
    public get(key: string | string[], interpolateParams?: object) {
        return this.translateSrv.instant(key, interpolateParams);
    }

    /**
     * Adds a dictionary to the current module. The dictionary translations
     * are merged to any existing translations already in the module.
     * @param lang - ISO language code for the dictionary to be added: fi, en or sv
     * @param translations - A translations object in ngx-translate format
     */
    public addDictionaryToModule(lang: string, translations: object) {
        this.translateSrv.setTranslation(lang, translations, true);
    }

    /**
     * Set the language of the current user interface to the given language.
     * Should be called at least once at the beginning of the App.
     * @param lang - ISO language code for the language of the UI: fi (default), en or sv
     */
    public setLanguage(lang: string) {
        // TODO: Currently called at platform.ready().then() in
        // app.component.ts.  Check if could be called in some other place and
        // if the default language could be set somewhere in the modules.
        this.translateSrv.setDefaultLang(lang);
        this.translateSrv.use(lang);
    }

}
